<!--The content below is only a placeholder and can be replaced.-->
<ngx-loading-bar [includeSpinner]="false" height="4px"></ngx-loading-bar>
<div id="vm-wrapper">
  <div id="vm-overlay" class="overlay"></div>
  <div id="vm-primary-content">
    <loader></loader>
    <router-outlet></router-outlet>
  </div>
</div>
<p-toast></p-toast>
<p-confirmDialog ></p-confirmDialog>

